import { PackageEvidence } from '@cadstrom/cadstrom-shared';

/** An evidence entry that carries the viewer's own stance. */
export interface ViewerVotedEntry {
	/** The viewer's current stance; null when they hold none. */
	myVote: PackageEvidence.EvidenceVotePolarity | null;
}

/**
 * The evidence entry as it reads once the viewer's vote is replaced by a new stance. Only the viewer's stance changes;
 * the verdict and tallies wait for the server, which alone knows the viewer's standing. Pure; the input entry is not
 * modified.
 *
 * @param entry - The entry as last read.
 * @param polarity - The viewer's new stance; `Withdrawn` clears it.
 * @returns The entry with `myVote` updated.
 */
export function applyViewerVote<Entry extends ViewerVotedEntry>(
	entry: Entry,
	polarity: PackageEvidence.EvidenceVotePolarity,
): Entry {
	return { ...entry, myVote: polarity === PackageEvidence.EvidenceVotePolarity.Withdrawn ? null : polarity };
}
